
import React, {useContext, useEffect} from 'react';
import {DesktopPage} from '../../../clean-components/desktop-page/desktop-page';
import ServicesOperatorsComponent from '../../../clean-components/services-operators/services-operators';
import {HeaderContext} from '../../../services/header/header.context';

export function ServicesDesktop() {
    const HeaderService = useContext(HeaderContext);
    const headerConfig= {
        title: 'translation:misc_services_operators_title',
        backIcon: true,
        closeIcon: false,
        logoIcon: false,
        customClassName: {
            'backgroundColor': 'var(--gris-fons-amb)',
        },
    };

    useEffect(() => {
        if (HeaderService.headerConfig.title != headerConfig.title) {
            HeaderService.initHeader(headerConfig);
        }
    }, [HeaderService.headerConfig]);

    return <DesktopPage config={headerConfig}>
        <ServicesOperatorsComponent/>
    </DesktopPage>;
}
